exports = module.exports = require("../../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".wheel-info {\n  display: block;\n  color: #666666;\n  font-size: 14px;\n  font-family: 'latoregular';\n  text-align: center;\n  margin-top: 20px;\n  margin-bottom: 10px;\n  opacity: 0.3;\n}\n", ""]);

